import React from 'react';

import { Loader } from '@atlas/ui';

import useBonuses from 'common/Hooks/useBonuses';
import BonusTable from 'components/ClientProfile/Bonuses/DepositBonuses/BonusTable';
import SeoPageText from 'components/SeoPage/SeoPageText';

const DepositBonuses = () => {
  const { activateBonus, activeBonuses, bonuses, deactivateBonus, isLoading, wallet } =
    useBonuses();

  if (isLoading) {
    return <Loader className="relative" />;
  }

  return (
    <>
      <BonusTable
        activateBonus={activateBonus}
        activeBonuses={activeBonuses}
        bonuses={bonuses}
        deactivateBonus={deactivateBonus}
        wallet={wallet}
      />
      <SeoPageText />
    </>
  );
};

export default DepositBonuses;
